function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "git-compare-outline",
  transform: "translate(-3.375 -0.659)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11901",
  "data-name": "Path 11901",
  d: "M22.769,14.038,16.875,8.144,22.769,2.25",
  transform: "translate(3.833 0)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.25
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11902",
  "data-name": "Path 11902",
  d: "M14.555,24.75l5.894,5.894-5.894,5.894",
  transform: "translate(3.115 6.97)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.25
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11903",
  "data-name": "Path 11903",
  d: "M13.341,7.8a4.42,4.42,0,1,1-4.42-4.42A4.42,4.42,0,0,1,13.341,7.8Z",
  transform: "translate(0 0.348)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.25
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11904",
  "data-name": "Path 11904",
  d: "M33.591,30.3a4.42,4.42,0,1,1-4.42-4.42,4.42,4.42,0,0,1,4.42,4.42Z",
  transform: "translate(6.273 7.318)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.25
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11905",
  "data-name": "Path 11905",
  d: "M18,6.75h7.736a5.526,5.526,0,0,1,5.526,5.526V31.8",
  transform: "translate(4.182 1.394)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.25
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11906",
  "data-name": "Path 11906",
  d: "M21.066,35.174H13.331A5.526,5.526,0,0,1,7.8,29.648V10.125",
  transform: "translate(1.024 2.439)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.25
}));

var SvgGitCompareOutline = function SvgGitCompareOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.614,
    height: 44.44,
    viewBox: "0 0 37.614 44.44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGitCompareOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/git-compare-outline.67a8f329.svg";
export { ForwardRef as ReactComponent };